import { ApolloError } from '@apollo/client'
import {
  ExceptionCategories,
  getMagentoErrorCategory,
} from '@emico-utils/magento-graphql-error-categories'
import { GraphQLError, GraphQLFormattedError } from 'graphql'

/**
 * @returns Returns true if a error was encountered and handled
 */
export function handleCartError(
  error: ApolloError | GraphQLError | GraphQLFormattedError<Record<string, any>> | undefined,
  setCartId: (id: string | undefined) => void,
) {
  const errorCategory = getMagentoErrorCategory(error)
  const isInvalidCartId = errorCategory === ExceptionCategories.NO_SUCH_ENTITY
  // This may occur if the login token expired or does not match the token used
  // to create the cart. This is actually a real error, but since the user can
  // not fix it all we can do is forget the cart. If it's a logged in cart, they
  // will get it back upon logging in.
  const isAuthorization = errorCategory === ExceptionCategories.AUTHORIZATION

  if (!isInvalidCartId && !isAuthorization) {
    return false
  }

  // The user can no longer interact with the cart, to allow customers to shop
  // again we just forget the cart.
  setCartId(undefined)

  return true
}
